import { Typography } from '@mui/material';
import { StyledTooltip, colors } from 'remote/global';
import { HelpOutline } from '@mui/icons-material';

function EndAdornment({ text }: { text: string }) {
  return (
    <Typography
      sx={{ color: colors.gray3, fontSize: '13px', userSelect: 'none', pointerEvents: 'none' }}
    >
      {text}
    </Typography>
  );
}

function TooltipTableHeader({ tooltip, children }: { tooltip: string; children: any }) {
  return (
    <StyledTooltip title={tooltip} placement='top'>
      <Typography
        sx={{ fontSize: '14px', fontWeight: 500, color: colors.uiBlue600, lineHeight: '20px' }}
      >
        {children}{' '}
        {tooltip != null && tooltip.length > 0 && (
          <HelpOutline sx={{ fontSize: '14px', verticalAlign: 'middle' }} />
        )}
      </Typography>
    </StyledTooltip>
  );
}

export { EndAdornment, TooltipTableHeader };
